import { gql } from '@apollo/client';

const Fragments = {
  contentType: gql`
    fragment contentType on ContentType {
      id
      code
      name
      isFileType
    }
  `,
  contentTypeXUserGroup: gql`
    fragment contentTypeXUserGroup on ContentTypeXUserGroup {
      contentTypeId
      userGroupId
      canRead
      canWrite
      canDelete
      canVerify
    }
  `
};

export default Fragments;
